import React from "react";
import { useAuth } from "@/App";
import { LayoutDashboard, Users, Store, Package, Wallet, Image, GitBranch, Film, Tag, Banknote, BarChart3, FileText, ShieldCheck } from "lucide-react";
import { PanelShell } from "./PanelShell";

const MENU = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/admin" },
  { icon: Package, label: "Products", path: "/admin/products" },
  { icon: Store, label: "Sellers", path: "/admin/sellers" },
  { icon: Users, label: "Users", path: "/admin/users" },
  { icon: Tag, label: "Brands", path: "/admin/brands" },
  { icon: Banknote, label: "Finance", path: "/admin/finance" },
  { icon: FileText, label: "Applications", path: "/admin/applications" },
  { icon: Film, label: "Reels", path: "/admin/reels" },
  { icon: Wallet, label: "Withdrawals", path: "/admin/withdrawals" },
  { icon: ShieldCheck, label: "KYC Review", path: "/admin/kyc" },
  { icon: GitBranch, label: "MLM Settings", path: "/admin/mlm" },
  { icon: BarChart3, label: "Analytics", path: "/admin/analytics" },
  { icon: Image, label: "Content", path: "/admin/content" },
];

const AdminLayout = ({ children, title }) => {
  const { user } = useAuth();
  return (
    <PanelShell
      badge="Admin Panel"
      menuItems={MENU}
      testIdFor={(i) => `admin-nav-${i.label.toLowerCase().replace(" ", "-")}`}
      logoutRedirect="/admin-login"
      logoutTestId="admin-logout-btn"
      title={title}
      headerRight={
        <span className="text-sm text-primary-100 truncate max-w-[200px]">
          <strong className="text-white">{user?.name}</strong>
          <span className="hidden sm:inline ml-2 text-primary-200">({user?.role})</span>
        </span>
      }
    >
      {children}
    </PanelShell>
  );
};

export default AdminLayout;
